import React from 'react';
import withStyles from 'react-jss';
import { useTranslation } from 'react-i18next';

const linkStyles = {
  color: (props) => ({
    color: props.color,

    '&:hover': {
      backgroundColor: 'white',
      textDecoration: 'underline',
      color: props.color,
    },
  }),
};

function AddRow(props) {
  const { handleAddRowSelected, electivesRowAdded } = props;
  const { t } = useTranslation();

  return (
    <button
      className={[
        'ecap-add-row-link',
        props.classes.color,
        props.overRideStyle,
      ].join(' ')}
      style={{ visibility: electivesRowAdded ? 'hidden' : 'visible' }}
      // Not all 'Next Buttons' just need to go to another page, some might need you to save info in the redux store
      onClick={() => {
        handleAddRowSelected();
      }}
      onKeyDown={(e) => {
        if (['Enter'].includes(e.key)) handleAddRowSelected();
      }}
      type="button"
      data-cy="ecap-add-row-link"
      disabled={electivesRowAdded}
    >
      {t('Add Another Row of Electives')}
    </button>
  );
}

export default withStyles(linkStyles)(AddRow);
